import { FC, useEffect, useRef } from 'react';
import { NavigationItem } from 'components/navigation/utils/libs';
import UserActions from 'components/navigation/verticalNavigation/userActionsMenu/Profile';
import { User } from 'types/User';
import { modalRoutes } from 'constants/routes';
import PerfectScrollbar from 'perfect-scrollbar';
import UserSubActions from 'components/navigation/verticalNavigation/userActionsMenu/UserActionsMenu';
import clsx from 'clsx';
import {
  useVerticalNavigation,
  VerticalNavigationProvider,
} from './verticalNavigation/provider/VerticalNavigationProvider';
import { Divider } from '@kontentino/ui';
import { useActiveModalRoute } from 'context/ModalRouter';
import Logo from './verticalNavigation/Logo';
import AuthenticatedNavigationContent from './verticalNavigation/AuthenticatedNavigationContent';

type Props = {
  menuItems: NavigationItem[];
  user: Pick<User, 'role' | 'avatar' | 'name'>;
  activeItem?: NavigationItem;
};

const VerticalNavigationContent: FC<Props> = (props) => {
  const { wrapperRef } = useVerticalNavigation();
  const activeWelcomeModalRoute = useActiveModalRoute(modalRoutes.WELCOME);

  const scrollbar = useRef<PerfectScrollbar>();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      scrollbar.current = new PerfectScrollbar(ref.current);
    }
  }, [ref]);

  return (
    <div
      className={clsx('tw-relative', {
        'tw-z-[1001]': !!activeWelcomeModalRoute,
      })}
      ref={wrapperRef}
    >
      <nav
        className={
          'tw-user-select-none tw-absolute tw-z-[20] tw-hidden !tw-h-full tw-w-[65px] tw-flex-col tw-border-r tw-border-grayscale-20 tw-bg-white tw-pt-4 sm:tw-flex'
        }
      >
        <Logo data-cy="navigation-link-default" />

        <div
          className={
            'tw-relative tw-my-4 tw-flex tw-flex-1 tw-flex-col tw-justify-between tw-overflow-y-auto'
          }
        >
          <div className="tw-flex tw-flex-col tw-gap-y-4 tw-px-[10px]">
            <AuthenticatedNavigationContent
              menuItems={props.menuItems}
              activeItem={props.activeItem}
            />
          </div>
        </div>

        <UserSubActions />
        <Divider className="tw-my-4 !tw-w-8 tw-self-center" />
        <UserActions user={props.user} />
      </nav>
    </div>
  );
};

const VerticalNavigation: FC<Props> = (props) => (
  <VerticalNavigationProvider {...props}>
    <VerticalNavigationContent {...props} />
  </VerticalNavigationProvider>
);

export default VerticalNavigation;
